// icon-button — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    height: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    outline: none;
  }

  :host([size="xs"]) {
    width: var(--run-icon-button-size-xs, var(--run-size-touch-xs, 28px));
    height: var(--run-icon-button-size-xs, var(--run-size-touch-xs, 28px));
  }
  :host([size="sm"]) {
    width: var(--run-icon-button-size-sm, var(--run-size-touch-sm, 36px));
    height: var(--run-icon-button-size-sm, var(--run-size-touch-sm, 36px));
  }
  :host([size="md"]) {
    width: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    height: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
  }
  :host([size="lg"]) {
    width: var(--run-icon-button-size-lg, var(--run-size-touch-lg, 52px));
    height: var(--run-icon-button-size-lg, var(--run-size-touch-lg, 52px));
  }

  :host([data-disabled]) {
    opacity: var(--run-icon-button-disabled-opacity, var(--run-opacity-state-disabled, 0.38));
    pointer-events: none;
  }

  :host(:focus-visible) {
    outline: var(--run-icon-button-focus-ring-width, 2px) solid
      var(--run-icon-button-focus-ring-color, var(--run-color-focus-ring, var(--run-color-intent-primary-base)));
    outline-offset: var(--run-icon-button-focus-ring-offset, var(--run-space-focus-offset, 2px));
  }

  :host(:focus:not(:focus-visible)) {
    outline: none;
  }

  [part="button"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;

export function render(host) {
  const { icon, label, size, variant, disabled, loading } = host;

  const sr = host.shadowRoot;
  let btn = sr.querySelector('run-button');

  if (!btn) {
    // First render: build structure from scratch
    sr.innerHTML = `
      <run-button part="button" variant="${variant}" size="${size}">
        ${loading
          ? `<run-spinner part="spinner" size="${size}" aria-hidden="true"></run-spinner>`
          : `<run-icon part="icon" name="${icon}" size="${size}" aria-hidden="true"></run-icon>`
        }
      </run-button>
    `;
    btn = sr.querySelector('run-button');
  } else {
    // Subsequent renders: patch in-place to preserve element references
    btn.setAttribute('variant', variant);
    btn.setAttribute('size', size);

    // Swap inner child only when loading state changes
    const hasSpinner = !!sr.querySelector('run-spinner');
    if (loading && !hasSpinner) {
      btn.innerHTML = `<run-spinner part="spinner" size="${size}" aria-hidden="true"></run-spinner>`;
    } else if (!loading && hasSpinner) {
      btn.innerHTML = `<run-icon part="icon" name="${icon}" size="${size}" aria-hidden="true"></run-icon>`;
    } else if (!loading) {
      const iconEl = sr.querySelector('run-icon');
      if (iconEl) {
        iconEl.setAttribute('name', icon);
        iconEl.setAttribute('size', size);
      }
    } else {
      const spinnerEl = sr.querySelector('run-spinner');
      if (spinnerEl) spinnerEl.setAttribute('size', size);
    }
  }

  // Sync disabled state
  if (disabled) {
    btn.setAttribute('disabled', '');
  } else {
    btn.removeAttribute('disabled');
  }

  // Sync aria-label
  if (label) {
    btn.setAttribute('aria-label', label);
  } else {
    btn.removeAttribute('aria-label');
  }
}